import {
    type AbacPolicy,
    abacPolicyValidator,
} from "@vesta/vos-types/modules/workspaceLevel/ottopilotAuthorization/domain/AbacPolicy";
import {z as zod} from "zod";

export type OttopilotLeaderboardWorkspaceCapabilityConfiguration = {
    accessControlPolicies: Array<AbacPolicy>;
};

export const ottopilotLeaderboardWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotLeaderboardWorkspaceCapabilityConfiguration> = zod.strictObject({
    accessControlPolicies: abacPolicyValidator.array(),
});
